import { EditorState } from "draft-js";
import { Alignment, IEditorHelpers, IUpdateEditorParams } from "./types";

export const updateEditorState = ({ onChange, getEditorState }: IEditorHelpers) => ({
  data,
  entityKey,
  contentState,
}: IUpdateEditorParams) => {
  const newContentState = contentState.mergeEntityData(entityKey, data);
  const currentEditorState = getEditorState();
  const newEditorState = EditorState.push(currentEditorState, newContentState, "change-block-data");
  onChange(newEditorState);
};

export const getAligmentClass = (alignment: Alignment) =>
  ["right", "left"].includes(alignment) ? `rdw-image-${alignment}` : "rdw-image-center";
